import React, { useEffect, useState } from "react";
import { getPrivacyPolicy } from "services/privacyPolicyServices";
import navigationAction from "redux/navigation/actions";
import minilogo from "assets/images/logo.png";
import logo from "assets/images/icon_logo.svg";
import "react-quill/dist/quill.snow.css";

const { success, error } = navigationAction;

function PrivacyPolicy(props) {
  const { mini, miniDrawerWidth } = props;
  const [pp, setPP] = useState("");

  let fetchPrivacyPolicy = async () => {
    await getPrivacyPolicy({ Privacy_Policy_for: "Merchant" }).then(
      response => {
        if (response.success) {
          success(response.mess);
          setPP(response.data.Privacy_Policy_description);
        } else {
          error(response.message);
        }
      }
    );
  };
  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  return (
    <div className="tnc-header">
      <div className="tnc-heading w-100">
        <div className="logo-text simple-text fs-20 bold-text">
          <img
            src={mini && miniDrawerWidth !== "260px" ? logo : minilogo}
            alt=""
          />
        </div>
      </div>
      <div className="container tnc-container">
        <div className="">
          <h4 className="mb-3 mt-2">Privacy Policy</h4>
          <p dangerouslySetInnerHTML={{ __html: pp }}></p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
